"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _XWMMMXUKcjs = require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/collection/collection.tsx
var _misc = require('@ariakit/core/utils/misc');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useCollection = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useCollection2({ store, ...props }) {
    const context = _XWMMMXUKcjs.useCollectionProviderContext.call(void 0, );
    store = store || context;
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _XWMMMXUKcjs.CollectionScopedContextProvider, { value: store, children: element }),
      [store]
    );
    return _misc.removeUndefinedValues.call(void 0, props);
  }
);
var Collection = _PTOCUU2Dcjs.forwardRef.call(void 0, function Collection2(props) {
  const htmlProps = useCollection(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.Collection = Collection; exports.useCollection = useCollection;
